import { useState } from 'react';
import { css, cx } from '@linaria/atomic';
import { saveAs } from 'file-saver';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton } from '../../../naked';
import { useTooltip } from '../../tooltip';
import { useImagePreviewActions, useImagePreviewValues } from '../provider/image-preview.provider';
import { controlStyles } from './constants';
import { ZoomSlider } from './zoom-slider';

const hoverableControlStyle = css`
  width: fit-content;
  &:hover {
    background: ${theme.colors.white};
    transition: all 0.2s ease;
  }
`;

const iconStyle = css`
  background: transparent;
  padding: 0;
`;

const controlsContainerStyle = css`
  display: flex;
  width: 100%;
  align-items: flex-end;
`;

const controlsContentStyle = css`
  display: flex;
  gap: ${theme.spacing(0.5)};
  width: 100%;
  justify-content: center;
`;

interface ControlIconProps {
  name: IconName;
  onClick: () => void;
  tooltipMessage?: string;
}

const ControlIcon = ({ name, onClick, tooltipMessage }: ControlIconProps) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip();
  const [hovered, setHovered] = useState(false);
  return (
    <>
      <NakedButton
        {...triggerProps}
        className={cx(controlStyles, hoverableControlStyle)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
      >
        <Icon name={name} color={hovered ? 'default' : 'white'} className={iconStyle} />
      </NakedButton>
      {tooltipMessage && <Tooltip {...tooltipProps}>{tooltipMessage}</Tooltip>}
    </>
  );
};

export const Controls = () => {
  const { src, rotationDegree } = useImagePreviewValues();
  const { setRotationDegree } = useImagePreviewActions();

  //*This is a temporary check until we find a way on how to handle this inside the electron shell */
  //@ts-ignore since window.shell is defined in the electron environment
  const showPopout = typeof window !== 'undefined' && !window.shell?.isShell;

  return (
    <div
      className={controlsContainerStyle}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={controlsContentStyle}>
        <ControlIcon
          name='update-small'
          onClick={() => setRotationDegree((rotationDegree + 90) % 360)}
          tooltipMessage='Rotate'
        />
        <ZoomSlider />
        <ControlIcon name='download-small' onClick={() => saveAs(src)} tooltipMessage='Download' />
        {showPopout && (
          <ControlIcon name='pop-out-small' onClick={() => open(src, '_blank')} tooltipMessage={'Open in new window'} />
        )}
      </div>
    </div>
  );
};

Controls.displayName = 'Controls';
